export default __webpack_public_path__ + "static/media/Scientific-gaming.53ee63cd.png";